import API from '../api';
import {
    PROPERTY_LOCKOUT_SOURCE_ENDPOINT,
    PROPERTY_LOCKOUT_DESTINATION_ENDPOINT,
    PROPERTY_LOCKOUT_CREATE_ENDPOINT,
    PROPERTY_LOCKOUT_DELETE_ENDPOINT,
    PROPERTY_LOCKOUT_UPDATE_ENDPOINT,
} from '../endpoints';


export default {
    namespaced: true,

    state() {
        return {
            sourceItems: [],
            destinationItems: [],
            options: []
        };
    },
    getters: {
        sourceItems: state => state.sourceItems,
        destinationItems: state => state.destinationItems,
        options: state => state.options,
    },
    mutations: {
        setSourceItems(state, { data }) {
            state.sourceItems = data.source_properties.map(property => {
                return {
                    value: property.id,
                    text: property.name,
                };
            });
        },
        setDestinationItems(state, { data }) {
            state.destinationItems = data.source_properties.map(item => {
                return { value: item.id, text: item.name };
            });
        },
    },
    actions: {
        async fetchSourceItems({commit}) {
            commit('setSourceItems', await API.get(PROPERTY_LOCKOUT_SOURCE_ENDPOINT()));
        },
        async fetchDestinationItems({commit}) {
            commit('setDestinationItems', await API.get(PROPERTY_LOCKOUT_DESTINATION_ENDPOINT()));
        },
        async createLockout({commit, dispatch, state, getters}, data) {
            await API.post(PROPERTY_LOCKOUT_CREATE_ENDPOINT(), data);
        },
        async removeLockout({dispatch}, data) {
            await API.post(PROPERTY_LOCKOUT_DELETE_ENDPOINT(data));
        },
        async editLockout({dispatch}, {id, ...data}) {
            await API.post(PROPERTY_LOCKOUT_UPDATE_ENDPOINT(id),data);
        },
    }
};
